import { render, staticRenderFns } from "./MenuMessageTab.vue?vue&type=template&id=6f0b9f11&scoped=true"
import script from "./MenuMessageTab.vue?vue&type=script&lang=js"
export * from "./MenuMessageTab.vue?vue&type=script&lang=js"
import style0 from "./MenuMessageTab.vue?vue&type=style&index=0&id=6f0b9f11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b9f11",
  null
  
)

export default component.exports